import axios from "axios";
import router from "@/router"; // 直接导入 router 实例
import { BASE_API_URL } from "@/config";
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // console.log("config:", config);
    if (!localStorage.getItem("token") && !config.url.includes("login")) {
      router.push({ name: "登录" });
      return;
    }

    // 添加请求头等前置处理
    // config.headers['Authorization'] = 'Bearer' + ' ' + localStorage.getItem('token')
    // config.headers["Admin-Token"] = localStorage.getItem("token");
    config.headers["Authorization"] = config.url.includes("login")
      ? "Basic " + btoa("admin:admin")
      : localStorage.getItem("token");
    // config.headers["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
    config.headers["Content-Type"] = "application/json;charset=UTF-8";
    return config;
  },
  (error) => {
    // 请求错误处理
    // console.log('Request Error:', error)
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // console.log("response0:", response);
    // 响应后处理
    if (response.status === 200 && response.data.code === 200) {
      //   console.log("response.data.data:", response.data);
      return Promise.resolve(response.data);
    } else if (response.data.code === 401) {
      router.push({ path: "/login" });
      localStorage.removeItem("token");
    } else {
      return Promise.reject(response.data);
    }
  },
  (error) => {
    // console.log("Response Error:", error);
    return Promise.reject(error);
  }
);
const request = async (url, { method, data }) => {
  if (url === "/prod-api/homeservice/contact/list") {
    console.log("request:", url, method, data);
  }

  // return await service[method](api + url, data);

  return await service[method](
    BASE_API_URL + url,
    method === "get" ? { params: data } : data
  );
};
export default request;
